import React, {ChangeEvent, MouseEventHandler, useEffect, useState} from "react";
import Box from "@mui/material/Box";
import {
    Button,
    Grid, InputBase,
    MenuItem, Pagination,
    Paper, styled,
    Typography
} from "@mui/material";
import { Icon } from '@iconify/react';
import IconButton from "@mui/material/IconButton";
import {ExportTable} from "../components/ModelComponents/ExportTable";
import {useNavigate} from "react-router-dom";
import {
    DataGrid,
    GridColDef, GridColumns, gridPageCountSelector,
    gridPageSelector, gridPageSizeSelector, GridToolbarContainer, GridToolbarExport,
    useGridApiContext,
    useGridSelector,
    GridCellValue,
    GridApi
} from "@mui/x-data-grid";
import Skeleton from "@mui/material/Skeleton";
import services from "../services";
import {Model} from "../components/Model";
import {AddNewDevice} from "../components/ModelComponents/AddNewDevice";
import {ViewUserDevices} from "../components/ModelComponents/ViewUserDevices";
import {UsersDataTable} from "../components/datatables/UsersDataTable";
import {AddNewUser} from "../components/ModelComponents/AddNewUser";


interface Device {
    id:number,
    imei:"string",
    category_id:number,
    created_at:Date
}

interface DevicesData {
    id:number,
    name:string,
    logo:string,
}

export interface CurrentUser {
    id? : number,
    email?:string,
    uuid?:string
}

var orignalTableData : any = [];


export const Users = () =>{
    const [model,setModel] = useState<boolean>(false)
    const handleOpen = () => setModel(true)
    const handleClose = () => setAddDeviceModel(false)
    const handelCloseViewDevice = () => setAddViewDevicesModel(false)
    const handelCloseViewAddUser = () => setOpenAddNewUserModel(false)
    const [perPage, setPerPage] = React.useState<number>(10);
    const [tableData , setTableData] = useState<any>([])

    const [addDeviceModel,setAddDeviceModel] = useState<boolean>(false)
    const [addViewDevicesModel,setAddViewDevicesModel] = useState<boolean>(false)

    const [searchKey,setSearchKey] = useState<string>('')

    const [tableskeleton,setTableSkeleton] = useState<boolean>(false)

    const [currentuser,setCurrentUser] = useState<CurrentUser>({})

    const [openAddUserModel,setOpenAddNewUserModel] = useState<boolean>(false)

    const AddDeviceModelComponent = () =>{
        return(
            <AddNewDevice handleClose={handleClose} adminAccess={true} userEmail={currentuser.email}/>
        )
    }

    const ViewDeviceModelComponent = () =>{
        return(
            <ViewUserDevices  id={currentuser.id} uuid={currentuser.uuid}/>
        )
    }

    const ViewAddNewUserComponent = () =>{
        return(
            <AddNewUser handleClose={handelCloseViewAddUser} refreshUsers={getUsers} />
        )
    }



    const handleSearch = (keyword : string) =>{


        let search_result = tableData.filter((o : any) => (JSON.stringify(o)).includes(keyword))
        setTableData(search_result)


        if(keyword.length===0)
        {
            setTableData(orignalTableData)
        }
    }



    const navigator = useNavigate()
    const token = localStorage.getItem("token")

    const modelComponent = ()=>{
        return (
            <ExportTable />
        )
    }


    useEffect(()=>{
        getUsers()
    },[])

    const getUsers = () =>{
        setTableSkeleton(true)
        services.GetUsersList()
            .then(res=> {
                let i = 1
                res.data.forEach((d:any)=>{
                    d.uniqueId = i++
                    d.dob = new Date(d.dob).toLocaleDateString()
                })
                setTableSkeleton(false)
                setTableData(res.data)
                orignalTableData = res.data
            })
            .catch(error=>setTableSkeleton(false))
    }

    return (
        <Box sx={{ flexGrow: 1,padding:"0px 30px" }}>
            <Model
                open={addViewDevicesModel}
                handleClose={handelCloseViewDevice}
                Component = {ViewDeviceModelComponent}
            />
            <Model
                open={addDeviceModel}
                handleClose={handleClose}
                Component = {AddDeviceModelComponent}
            />
            <Model
                open={openAddUserModel}
                handleClose={handelCloseViewAddUser}
                Component = {ViewAddNewUserComponent}
            />
            <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                paddingTop={1}
                paddingBottom={4}
            >
                <Grid xs={6} item>
                    <Typography
                        fontSize={32}
                        fontWeight={700}
                        color="#081735"
                    >
                        All Users
                    </Typography>
                </Grid>
                <Grid
                          item
                          justifyContent="space-between"
                          alignItems="center"
                          display={"flex"}
                          md={5}
                >

                    <Grid item md={7}>
                        <Paper
                            component="form"
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                border:"1px solid #8F95B2",
                                background:"none",
                                borderRadius:"20px",
                                boxShadow:"none",
                                padding:"6px",
                                // width:400
                            }}
                        >
                            <InputBase
                                sx={{ ml: 1, flex: 1 }}
                                onChange={e=>{handleSearch(e.target.value)}}
                                placeholder="Search user name..."
                                inputProps={{ 'aria-label': 'search google maps' }}
                            />
                            <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
                                <Icon icon="ant-design:search-outlined" color="#8F95B2" style={{borderRadius:"10px"}} />
                            </IconButton>
                        </Paper>
                    </Grid>
                    <Grid item>
                        <Button
                            onClick={()=>{setOpenAddNewUserModel(true)}}
                            variant="contained"
                            sx={{
                                borderRadius:"16px",
                                background:"#089BAB",
                                textTransform:"none",
                                color:"#F9FAFC",
                                fontWeight:700,
                                padding:2,
                                boxShadow:"none",
                                fontSize : "16px"
                            }}> <Icon icon="carbon:add-filled" /> &nbsp; Add a new User</Button>
                    </Grid>

                </Grid>
            </Grid>


            <UsersDataTable
                showFooter={false}
                data={tableData}
                height={600}
                skeleton={tableskeleton}
                hideActionsColumn={false}
                setCurrentUser={setCurrentUser}
                setAddViewDevicesModel={setAddViewDevicesModel}
                setAddDeviceModel={setAddDeviceModel}
            />
        </Box>
    )
}


